export default "__VITE_ASSET__BH4bx7pv__"